module.exports = __webpack_public_path__ + "img/meeting-cover.cd09b527.png";